// Imported and modified from https://github.com/valor-software/ng2-table
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgTableComponent } from './ng-table/ng-table.component';
import { NgTableFilteringDirective } from './ng-table/ng-table-filtering.directive';
import { NgTablePagingDirective } from './ng-table/ng-table-paging.directive';
import { NgTableSortingDirective } from './ng-table/ng-table-sorting.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [NgTableComponent, NgTableFilteringDirective, NgTablePagingDirective, NgTableSortingDirective],
  exports: [NgTableComponent, NgTableFilteringDirective, NgTablePagingDirective, NgTableSortingDirective]
})
export class Ng2TableModule {
}
